import { render, staticRenderFns } from "./MyChildren.vue?vue&type=template&id=57f0bca5&scoped=true&"
import script from "./MyChildren.vue?vue&type=script&lang=js&"
export * from "./MyChildren.vue?vue&type=script&lang=js&"
import style0 from "./MyChildren.vue?vue&type=style&index=0&id=57f0bca5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0bca5",
  null
  
)

export default component.exports